// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__jQlNf","namePhoneContainer":"style_namePhoneContainer__gHy7S"};